var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.99 139.49L109.59 146.9L126.79 139.73L123.39 132.73C127.05 130.14 130.29 126.91 132.95 123.14L139.96 126.5L147.05 109.27L139.71 106.73C140.48 102.17 140.45 97.59 139.68 93.18L147.01 90.6L139.84 73.4L132.83 76.8C130.24 73.15 127.01 69.9 123.24 67.25L126.61 60.23L109.38 53.14L106.83 60.51L106.81 60.48C102.25 59.71 97.67 59.74 93.26 60.51H93.18L90.63 53.14L73.4 60.23L76.77 67.25C73 69.9 69.77 73.14 67.18 76.8L60.17 73.4L53 90.6L60.33 93.18C59.56 97.59 59.52 102.17 60.3 106.73L52.96 109.27L60.05 126.5L67.06 123.14C69.71 126.91 72.96 130.14 76.62 132.73L73.22 139.73L90.42 146.9L93.03 139.5C97.59 140.27 102.58 140.26 107 139.49H106.99Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9996 119.14C110.554 119.14 119.11 110.584 119.11 100.03C119.11 89.4759 110.554 80.92 99.9996 80.92C89.4455 80.92 80.8896 89.4759 80.8896 100.03C80.8896 110.584 89.4455 119.14 99.9996 119.14Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.66 139.13H165.62V161.11M175.75 100C175.75 58.15 141.82 24.22 99.97 24.22C72.54 24.22 48.52 38.79 35.21 60.62M34.38 38.9V60.88H56.34M24.25 100C24.25 141.85 58.18 175.78 100.03 175.78C127.46 175.78 151.48 161.21 164.79 139.38",
    stroke: "url(#paint0_linear_285_3794)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_285_3794",
    x1: 22.25,
    y1: 100,
    x2: 177.75,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2074D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest3);
export default __webpack_public_path__ + "static/media/test3.728083dff1cc3218f84237596e458eb2.svg";
export { ForwardRef as ReactComponent };